import React, { useState, useEffect, useRef, useCallback, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Box, Grid, Paper, Skeleton } from '@mui/material'
import _ from "lodash"
import { getViewInstance } from "../actions/viewinstance";
import Header from "./layouts/Header";
import Loading from "./Loading";
import DynamicComponent from "./partials/DynamicComponent";
import ReactToPrint, { useReactToPrint } from "react-to-print";

import ResponsiveRectangle from "./partials/skeletons/ResponsiveRectangle";
import Footer from "./layouts/Footer";

import { fetchViewInstances, selectViewInstanceById } from "../reducers/reuseable_vi";
const PrintStyles = () => (
    <style>
        {`
        @media print {
            @page {
                size: A4;
                margin: 2mm; /* Defines the printable area */
            }

            /* Add resets to prevent browser defaults from interfering */
            html, body {
                background: #fff !important;
                color: #000 !important;
                margin: 0 !important;
                padding: 0 !important;
                width: 100%;
            }

            .no-print {
                display: none !important;
            }

            /* Let the container be a simple block element */
            .print-container {
                width: 98% !important;
                padding: 0 !important;
                background: none !important;
            }
            
            .print-header, .print-footer {
                display: block !important;
                position: static !important;
                box-shadow: none !important;
                background: none !important;
                width: 100%;
            }
            
            .report-legend-container {
                display: block !important;
            }

            /* Ensure the grid takes up full width and has no conflicting margin */
            .print-main-grid {
                margin: 20px 0 0 0 !important;
                padding: 0 !important;
                width: 100% !important;
                box-sizing: border-box !important;
            }
        }
        `}
    </style>
);
 

const PhysicianSummary = (props) => {
    const { user: currentUser } = useSelector((state) => state.auth);
    const [loading, setLoading] = useState(false);
    const [callVI, setCallVI] = useState(false)
    useEffect(() => {
        if (window !== undefined) {
            window.scrollTo(0, 0)
        }
    }, [])
    const [searchParams] = useSearchParams();
    //const { viewInstance, settings } = useSelector(state => state.viewinstance)
    const viewInstance = useSelector(state => selectViewInstanceById(state,'PhysicianSummary'))
    const settings = viewInstance?.settings || {}
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [PrintView, setPrintView] = useState(false);
    const componentRef = useRef(null);
    const onBeforeGetContentResolve = React.useRef(null);
    const reactToPrintContent = React.useCallback(() => {
        return componentRef.current;
    }, [componentRef.current]);

    useEffect(() => { }, [PrintView])
    useEffect(() => {
        const startConversion = () => {
          if (window.hiqPdfConverter) {
            window.hiqPdfConverter.startConversion();
          }
        };
    
        // Ensure hiqPdfConverter is available and the component is ready
        if (typeof window.hiqPdfConverter !== 'undefined' && !loading) {
          startConversion();
        } else {
          // Add an event listener for when hiqPdfConverter becomes available
          window.addEventListener('hiqPdfConverterReady', startConversion);
    
          // Clean up the event listener when the component unmounts
          return () => {
            window.removeEventListener('hiqPdfConverterReady', startConversion);
          };
        }
      }, [loading]);
    const handleAfterPrint = React.useCallback(() => {
        setPrintView(false);

    }, []);

    const handleBeforePrint = React.useCallback(() => {
    }, []);

    const handleOnBeforeGetContent = React.useCallback(() => {
        setPrintView(true);
        return new Promise((resolve) => {
            onBeforeGetContentResolve.current = resolve;
            setTimeout(() => {
                setPrintView(true);
                resolve();
            }, 1000);
        });
    }, [setLoading, setPrintView]);

    const handleActualPrint = () => {
        setPrintView(true)
        handlePrint()
        // window.print()
    }

    window.onbeforeprint = () => handleActualPrint()

    const handlePrint = useReactToPrint({ 
        content: reactToPrintContent,
        documentTitle: "Physicians Summary Report",
        onBeforeGetContent: handleOnBeforeGetContent,
        onBeforePrint: handleBeforePrint,
        onAfterPrint: handleAfterPrint,
        removeAfterPrint: true
    });


    useEffect(() => {
        //IF EMPTY VI OR NOT THE DESIRED VI AND THE VI HAS NOT BEEN CALLED YET
        setLoading(true)
        if ((!viewInstance || !viewInstance.ReportPersonalPage) && !callVI) {
            //SO IT'S NOT CALLED MULTIPLE TIMES
            setCallVI(true)
            //CALL THE ACTION THAT FETCHES THE SERVICE AND UPDATES THE STATE
            dispatch(fetchViewInstances({authToken: currentUser.AuthToken, VIGuid:searchParams.get("vi"), VIName:"PhysicianSummary"}))
            //dispatch(getViewInstance(searchParams.get("vi"), currentUser.AuthToken))
            setLoading(false)
        }
        //WINDOW.LOCATION PROVIDES EXTRA CONTEXT SO WHEN TEH URL UPDATES THE APP UPDATES
    }, [window.location.pathname])

    /**
     * View instance return
     * ReportViewInstance:{
     *  ReportPage:[
     *      ReportFrame:[
     *          {"Visible":"1/0","Order":"","ComponentType":""}
     *          , {"Visible":"1/0","Order":"","ComponentType":""}
     *          , {"Visible":"1/0","Order":"","ComponentType":""}
     *          , {"Visible":"1/0","Order":"","ComponentType":""} 
     *      ]
     *  ]
     * }
     */

    const OrderedSections =
        viewInstance
        && viewInstance.ReportViewInstance
        && viewInstance.ReportViewInstance.ReportPage
        && viewInstance.ReportViewInstance.ReportPage[0].ReportFrame
        && [...viewInstance.ReportViewInstance.ReportPage[0].ReportFrame].sort(function (a, b) { return parseInt(a.Order) - parseInt(b.Order) })



    return (
        <Box ref={componentRef} className="print-container">
      <PrintStyles />
      {/* Remember to apply className="no-print" to the print button INSIDE your Header component */}
      <div className="print-header">
        <Header printFunction={() => { handleActualPrint() }} />
      </div>

      <Grid container direction="row" spacing={2} sx={{ marginTop: '150px', marginLeft: '-12px' }} alignItems="stretch" justifyContent="center" className="print-main-grid">

                {/** The idea is simple, we will send each array to a single component that will dictate its format */}
                {/** Each array will have a ComponentType attribute. [{ComponentType},{ComponentType},{ComponentType}] */}
                {/** This component type will load a specific component*/}

                { viewInstance && viewInstance.status==='success' && viewInstance.ReportViewInstance
                    && OrderedSections ? (

                    OrderedSections.map((reportComponent, index) => {
                        return (

                            <DynamicComponent component={reportComponent} settings={settings} delay={index} key={index} PrintView={PrintView} />

                        )
                    })
                ) : (
                    [1, 2, 3, 4, 5].map(x => {
                        return (
                            <Grid item xs={12}>
                                <Paper elevation={1} >
                                    <Skeleton variant="rectangular" animation="wave" sx={{ paddingTop: "30%" }} height={0} />
                                </Paper>
                            </Grid>
                        )
                    })

                )
                }



            </Grid>
            <Footer />

        </Box>
    );



};

export default React.forwardRef(PhysicianSummary);